import { getNextScreenPrefixId } from "../../framework/controls/simpleScreen";
import { ll } from "../../framework/core/ll";
import { ScreenObservable } from "../../framework/data/screen.observable";
import { getStateObject, setHistory, setTitle } from "../../framework/util";
import * as layout from "./resizeWindow";
import { makeHamburgerMenuOpen } from "./util/util";

export const screens: { [name: string]: Screen } = {};

export class Screen {

    id: number;
    name: string;
    screenId: string;
    drawerView: any;
    toolbar: JQuery;
    hamSection: JQuery;
    container: JQuery;
    breadCrumb: JQuery;
    hamburger: boolean;
    defaultScreenName: string;
    drawerTrigger: JQuery;
    leftColumnMenu: JQuery;
    leftColumn: JQuery;
    workspace: any;
    bannerHeight: number;
    twoColumnWorkspace: JQuery;
    subWorkspace: JQuery;
    fullWorkspace: any;
    subScreens: Screen[];
    parentScreen: Screen;

    constructor(options?) {
        options = options || {};
        options.name = options.name || "Screen";
        this.id = getNextScreenPrefixId();
        if (screens[options.name + this.id]) {
            throw new Error("A screen with that name already exists, choose a different name");
        }
        screens[options.name + this.id] = this;

        // Init Screen
        this.name = options.name;
        this.screenId = `${this.id}_${options.name}`;
        this.drawerView = options.drawerView;

        this.toolbar = $(`<div id="${this.screenId}Toolbar" class="top-toolbar"></div>`);
        this.hamSection = $('<section id="HamburgerMenu" class="container hamburger" style="width:0px; z-index: 10;"></section>');
        this.container = $(`<section id="${this.screenId}"></section>`);
        this.breadCrumb = $(`<li><a id="bc_${this.screenId}">${ll(this.name, true)}</a></li>`);
        this.container.append('<section class="left-column"></section>' +
                                '<section class="left-column-menu"></section>' +
                                '<section class="workspace container">' +
                                "</section>" +
                                '<section class="full-workspace container">' +
                                "</section>" +
                                '<section class="sub-workspace">' +
                                "</section>");

        if (options.hamburger) {
            this.hamburger = true;
            this.defaultScreenName = options.defaultScreenName;
            this.container.append(`<div id="${this.id}_DrawerTrigger" class="link bind-label drawer-trigger" style="left: 0;">` +
                                        `<div id="${this.id}_hamburgerIcon" class="hamburgerIcon hamburgerIcon--arrowalt">` +
                                            `<div class="hamburgerIcon-box">` +
                                                `<div class="hamburgerIcon-inner">` +
                                                `</div>` +
                                            `</div>` +
                                        `</div>` +
                                    `</div>`);
        } else {
            this.hamSection = $(`<div class='hidden'></div>`);
        }

        this.drawerTrigger = this.container.children(`#${this.id}_DrawerTrigger`);
        this.leftColumnMenu = this.container.children(".left-column-menu");
        this.leftColumn = this.container.children(".left-column");
        this.workspace = this.container.children(".workspace");
        this.workspace.observables = new ScreenObservable();

        this.subWorkspace = this.container.children(".sub-workspace");

        this.twoColumnWorkspace = this.container.children(".left-column,.workspace");

        this.fullWorkspace = this.container.children(".full-workspace");
        this.fullWorkspace.observables = new ScreenObservable();

        this.subScreens = [];

        var me = this;
        this.drawerTrigger.tie("click", function () {
            me.showHamburgerMenu(me.name);
        });

        if (options.fullWorkspace) {
            this.leftColumnMenu.remove();
        }
    }

    attach(options?) {
        options = options || {};
        options.mainDiv = options.mainDiv || $("#Main");
        options.topToolbarDiv = options.topToolbarDiv || $("#TopToolbar");

        $(this.hamSection).insertBefore($("#TopToolbar"));
        options.mainDiv.append(this.container);
        options.topToolbarDiv.append(this.toolbar);

        if (this.hamburger) {
            this.showHamburgerMenu(this.name);
            this.selectDefaultScreen();
            this.hideLeftColumnMenu();
        }
    }

    add(child) {
        this.subScreens.push(child);

        // debugger;
        child.parentScreen = this;
        child.container.addClass("sub-screen");
        child.breadCrumb = $(`<li class="js-breadcrumb-after-first"><a id="bc_${child.screenId}">${ll(child.name, true)}</a></li>`);
        this.breadCrumb.after(child.breadCrumb);
        this.subWorkspace.append(child.hamburger);
        this.subWorkspace.append(child.toolbar);
        this.subWorkspace.append(child.container);
    }

    remove(child) {
        // tslint:disable-next-line:no-conditional-assignment
        for (var node, i = 0; node = this.getSubScreen(i) ; i++) {
            if (node === child) {
                this.subScreens.splice(i, 1);
                delete child.parentScreen;
                child.toolbar.remove();
                child.container.remove();
                child.breadCrumb.nextAll().remove();
                child.breadCrumb.remove();

                return true;
            }

            if (node.remove(child)) {
                return true;
            }
        }

        return false;
    }

    destroy() {
        var me = this;

        $(me).trigger("closeScreen");

        if (me.parentScreen) {
            me.parentScreen.remove(me);
        }
    }

    getSubScreen(i) {
        return this.subScreens[i];
    }

    get(selector) {
        var me = this,
            container = null;

        if (selector.indexOf("#") > -1) {
            selector = selector.replaceAll("#", `#${me.id}_`);
        } else if (selector.indexOf(".") == 0) {
            container = `#${me.screenId}`;
        }

        var el = $(selector, container);
        return el;
    }

    hide(args?) {
        var me = this;
        args = args || {};

        if (args.fade) {
            me.container.stop().fadeTo(250, 0, function () {

            });
            me.toolbar.stop().fadeTo(250, 0, function () {
                me.toolbar.hide();
            });
        } else {
            me.container.hide();
            me.toolbar.hide();
        }
    }

    show(args?) {
        var me = this;
        args = args || {};

        if (args.noFade) {
            me.container.show();
            me.toolbar.show();
        } else {
            me.container.stop().fadeTo(750, 1).show();
            me.toolbar.stop().fadeTo(750, 1).show();
        }
    }

    hideWorkspaces(args?) {
        var me = this;
        args = args || {};

        if (args.noFade) {
            me.workspace.hide();
            if (me.leftColumn) {
                me.leftColumn.hide();
            }

            me.fullWorkspace.hide();
            me.subWorkspace.hide();
            if (!args.subWorkspace) {
                let menu = me.leftColumnMenu.find(".z-menu").data("kendoTreeView") as any;
                menu && menu.select(0);
            }
            me.leftColumnMenu.show().css("opacity", 1);
        } else {
            me.workspace.stop().fadeTo(250, 0, function () {
                me.workspace.hide();
            });
            if (me.leftColumn) {
                me.leftColumn.stop().fadeTo(250, 0, function () {
                    me.leftColumn.hide();
                });
            }
            me.fullWorkspace.stop().fadeTo(250, 0, function () {
                me.fullWorkspace.hide();
            });
            me.subWorkspace.stop().fadeTo(250, 0, function () {
                me.subWorkspace.hide();
                if (!args.subWorkspace) {
                    let menu = me.leftColumnMenu.find(".z-menu").data("kendoTreeView") as any;
                    menu && menu.select(0);
                }
                me.leftColumnMenu.show().css("opacity", 1);
            });
        }

        if (me.drawerTrigger.length ||
            (me.parentScreen && me.parentScreen.drawerTrigger.length)) {
            me.hideLeftColumnMenu();
        }

        if (args.hamburger && args.firstScreen) {
            $(`#${args.screenName}_LI`).find(".k-state-selected").removeClass("k-state-selected");
            $(`#${args.firstScreen}_LI`).click().focus();
            makeHamburgerMenuOpen(true);
        }

        layout.resizeWindow();
    }

    showWorkspace(args?) {
        var me = this,
            options;
        args = args || {};

        if (args.noFade) {
            me.workspace.show();
            if (me.leftColumn) {
                me.leftColumn.show();
                me.leftColumnMenu.hide();
            }
        } else {
            me.workspace.stop().fadeTo(750, 1).show();
            if (me.leftColumn) {
                me.leftColumn.stop().fadeTo(750, 1).show();
                me.leftColumnMenu.stop().fadeTo(250, 0, function () {
                    me.leftColumnMenu.hide();
                });
            }
        }

        layout.resizeWindow();
    }

    showHamburgerMenu(screenName?, firstScreen?) {
        var me = this;
        var hamMenu = $("#HamburgerMenu");
        var topToolbar = $(".top-toolbar");
        me.bannerHeight = $("#Banner").height();
        if ($("#ShowHideTopBanner") && $("#ShowHideTopBanner").hasClass("closed")) {
            me.bannerHeight = 0;
        }

        var hamburgerIcon = $(".hamburgerIcon");

        $("#HamburgerMenu").height($(document).height() - me.bannerHeight);
        if (hamMenu.width() == 185 || firstScreen) {
            $("#HamburgerMenu").hide();
            if (firstScreen) {
                $(`#${firstScreen}_LI`).click();
            }

            hamburgerIcon.removeClass("is-active");
            me.hideHamburgerMenu();
        } else {

            hamburgerIcon.addClass("is-active");
            var screenWidth = $("#Main").find(".full-workspace").width();
            topToolbar.animate(
                {
                    marginLeft: "200px",
                    width: screenWidth - 200
                },
                {
                    duration: 320,
                    queue: false
                }
            ).css("overflow", "visible");

            me.drawerTrigger.animate(
                {
                    marginLeft: "200px"
                },
                {
                    duration: 320,
                    queue: false
                });

            hamMenu.show().animate(
                {
                    width: "200px"
                },
                {
                    duration: 320,
                    queue: false,
                    complete: function () {
                        hamMenu.show();
                    }

                });

            me.drawerTrigger.animate(
                {
                    left: "0px"
                },
                {
                    duration: 320,
                    queue: true,
                    complete: function () {
                        layout.resizeWindow();
                    }
                });
        }
    }

    hideHamburgerMenu() {
        var me = this,
            hamMenu = $("#HamburgerMenu"),
            topToolbar = $(".top-toolbar"),
            hamburgerIcon = $(".hamburgerIcon"),
            screenWidth = $("#Main").find(".full-workspace").width();

        hamburgerIcon.removeClass("is-active");

        topToolbar.animate(
            {
                marginLeft: "0",
                width: screenWidth
            },
            {
                duration: 320,
                queue: false,
                complete: function () {
                    $("#HamburgerMenu").hide();
                    topToolbar.css("width", "auto");
                }
            }
        ).css("overflow", "visible");

        me.drawerTrigger.animate(
            {
                marginLeft: "0"
            },
            {
                duration: 320,
                queue: false
            });

        hamMenu.show().animate(
            {
                width: "0px"
            },
            {
                duration: 320,
                queue: false,
                complete: function () {
                    $("#HamburgerMenu").hide();
                }
            });

        me.drawerTrigger.animate(
            {
                left: "0px"
            },
            {
                duration: 320,
                queue: true,
                complete: function () {
                    layout.resizeWindow();
                }
            });
    }

    initHamburgerMenu(args?) {
        var me = this;

        args = args || {};
        var subScreens = args.screens || window.z;

        $("#HamburgerMenu").height(0);
        me.get(`#${me.name}TreeView`).tie("click", "li", function () {
            var node = $(this),
                subScreenName = node.data("value");
            // Only executes code if the item does not have sub items
            if (!node.data("expands")) {
                $("#HamburgerMenu").hide();
                me.get(`#${me.name}TreeView`).find(".k-in").removeClass("k-state-selected k-state-hover");
                $(".hamburger").css("background-color", "#333333");
                node.find(".k-in").addClass("k-state-selected");
                if (subScreens[subScreenName]) {
                    var options;
                    if (node.data("sub-value")) {
                        options = { name: subScreenName, parentScreen: me, codeType: node.data("sub-value")};
                    } else {
                        options = { name: subScreenName, parentScreen: me };
                    }

                    if (!args.ignoreUrlParams) {
                        me.setURLHistory(me, subScreenName);
                    } else {
                        args.ignoreUrlParams = false;
                    }
                    // tslint:disable-next-line:no-unused-expression
                    new subScreens[subScreenName](options);
                }

                window.scrollTo(0, 0);
            }
        });
        // Resizes the window to accomodate the size of the window after it expands and collapses.
        // A delay is set because kendo does not have support for executing code after these events.
        me.get(`#${me.name}TreeView`).data("kendoTreeView").bind("expand",
            () => window.setTimeout(layout.resizeWindow, 200));
        me.get(`#${me.name}TreeView`).data("kendoTreeView").bind("collapse",
            () => window.setTimeout(layout.resizeWindow, 200));
    }

    setURLHistory(me, subScreenName: string) {
        let split: string[],
            entity: string;

        if ((me.name as string).substr(0, 11) === "Maintenance") {
            entity = "Maintenance";
        } else {
            split = me.name.split("Main");
            entity = split[0];
        }

        setTitle(subScreenName);
        setHistory(entity, false, getStateObject(), subScreenName);
    }

    selectDefaultScreen() {
        var me = this;

        $(`#${me.defaultScreenName}_LI`).click();
        me.hideHamburgerMenu();
    }

    showFullWorkspace(args?) {
        var me = this;
        args = args || {};

        me.hideWorkspaces({ noFade: true });

        if (args.hamburger) {
            me.fullWorkspace.css("padding-top", 60);
            me.fullWorkspace.css("min-height", 350);
            if (!args.toolbar && me.drawerView) {
                var topToolbarLayout = me.drawerView();
                topToolbarLayout.options.zScreen = me;
                topToolbarLayout.render(me.toolbar);
            }

            if (args.screenName) {
                me.get(`#${args.screenName}DrawerTrigger`).tie("click", function () {
                    me.showHamburgerMenu(me, args.screenName);
                });
            }

            makeHamburgerMenuOpen(false);
        }

        if (args.noFade) {
            me.fullWorkspace.show();
            me.leftColumnMenu.hide();
        } else {
            me.fullWorkspace.stop().fadeTo(750, 1).show();
            me.leftColumnMenu.stop().fadeTo(250, 0, function () {
                me.leftColumnMenu.hide();
            });
        }

        if ($("#PortalContainer").is(":visible")) {
            layout.reduceWindow();
            layout.resizeToPortalContainer();
        } else if (!args.hamburger) {
            layout.resizeWindow();
        }
    }

    showSubWorkspace(args?) {
        var me = this;
        args = args || {};

        me.hideWorkspaces({ noFade: true, subWorkspace: true });
        me.hideSubWorkspaces({ noFade: true });

        if (args.noFade) {
            me.subWorkspace.show();
            if (args.full) {
                me.leftColumnMenu.hide();
            }
        } else {
            me.subWorkspace.stop().fadeTo(750, 1).show();
            if (args.full) {
                me.leftColumnMenu.stop().fadeTo(250, 0, function () {
                    me.leftColumnMenu.hide();
                });
            }
        }

        if ($("#PortalContainer").is(":visible")) {
            layout.resizeToPortalContainer();
        } else {
            layout.resizeWindow();
        }
    }

    hideSubWorkspaces(args?) {
        var me = this;
        args = args || {};

        if (args.noFade) {
            $.each(me.subScreens, function (index, sub) {
                sub.workspace.hide();
            });
        } else {
            $.each(me.subScreens, function (index, sub) {
                sub.workspace.stop().fadeTo(250, 0, function () {
                    sub.workspace.hide();
                });
            });
        }

        layout.resizeWindow();
    }

    hideLeftColumnMenu(args?) {
        var me = this;
        args = args || {};

        if (args.noFade) {
            me.leftColumnMenu.hide();
        } else {
            me.leftColumnMenu.stop().fadeTo(250, 0, function () {
                me.leftColumnMenu.hide();
            });
        }

        if (me.parentScreen &&
            me.parentScreen.leftColumnMenu) {
            me.parentScreen.leftColumnMenu.hide();
        }
    }

    reinit(args) {
        var me = this,
            deferred = $.Deferred();

        me.container.find(".validation-failure").removeClass("validation-failure");

        // Might use this later if we animate or something
        deferred.resolve();

        return deferred;
    }
}
